import constants from '../constants'
import Dispatcher from '../dispatcher'

const Actions = {
  changeAnchor: (id) => {
    Dispatcher.handleAppAction({
      type: constants.CHANGE_ANCHOR,
      item: id
    })
  },
}

export default Actions
